import { render, staticRenderFns } from "./user-panel.vue?vue&type=template&id=f37d9668&"
import script from "./user-panel.vue?vue&type=script&lang=js&"
export * from "./user-panel.vue?vue&type=script&lang=js&"
import style0 from "./user-panel.vue?vue&type=style&index=0&id=f37d9668&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports